import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { StaffMapTrackingRoutingModule } from './staff-map-tracking-routing.module';
import { StaffMapTrackingComponent } from './components/staff-map-tracking.component';
import { StaffMapTrackingServiceProxy } from '@shared/service-proxies/service-proxies';
import { SharedModule } from "../../shared/shared.module";
import { GenericMapComponent } from '@shared/components/generic-map/generic-map.component';

@NgModule({
  declarations: [StaffMapTrackingComponent],
  imports: [
    CommonModule,
    StaffMapTrackingRoutingModule,
    FormsModule,
    SharedModule
],
  providers: [
    StaffMapTrackingServiceProxy
  ],
  entryComponents: [ GenericMapComponent ]
})
export class StaffMapTrackingModule { }
